export let myVideo = {
  data() {
    return {
      videoLoadingStatus:false,
      videoPayStatus:false,
      myVideo:null,
    }
  },
  methods:{
    /**
     * 方式播放视频
     */
    playVideo(){
      if(!this.videoLoadingStatus){
        this.$message.info('视频加载中....');
      }
      else if(this.myVideo && typeof this.myVideo.play === 'function'){
        this.myVideo.play();
      }
      else {
        this.$message.error('视频对象获取失败');
      }
    },
    /**
     * 暂停视频播放
     */
    pauseVideo(){
      if(!this.videoLoadingStatus){
        this.$message.info('视频加载中....');
      }
      else if(this.myVideo && typeof this.myVideo.pause === 'function'){
        this.myVideo.pause();
      }
      else {
        this.$message.error('视频对象获取失败');
      }
    },
    /**
     * 监听 视频开始播放
     */
    videoListenerPlay(){
      console.log('开始播放');
      this.videoPayStatus = true;
    },
    /**
     * 监听 视频暂停播放
     */
    videoListenerPause(){
      console.log('播放暂停');
      this.videoPayStatus = false;
    },
    /**
     * 监听 视频播放结束
     */
    videoListenerEnd(){
      console.log('播放结束');
      this.videoPayStatus = false;
    },
  },
  mounted(){
    let myVideo = document.getElementById('myVideo');
    if(myVideo && typeof myVideo.play === 'function'){
      this.myVideo = myVideo
      // 视频加载完成
      myVideo.oncanplay = () => {
        console.log('视频准备就绪')
        this.videoLoadingStatus = true;
      };
      // 监听播放开始
      myVideo.addEventListener('play',this.videoListenerPlay);
      // 监听播放暂停
      myVideo.addEventListener('pause',this.videoListenerPause);
      // 监听播放结束
      myVideo.addEventListener('ended',this.videoListenerEnd);
    }
  },
  destroyed(){
    console.log('离开含有视频页');
    let myVideo = this.myVideo;
    if(myVideo && typeof myVideo.play === 'function'){
      myVideo.removeEventListener('play',this.videoListenerPlay);
      myVideo.removeEventListener('pause',this.videoListenerPause);
      myVideo.removeEventListener('ended',this.videoListenerEnd);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/placeOrder/components/video.js